import { signal, WritableSignal } from "@angular/core";
import { GeneralLedger } from "./model/general-ledger.model";

export class AppState {
}
